import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';

/**
 * L'id che il backend usa per dire «nessun canale»: `accessible_channels`
 * vuoto vuol dire tutti, `[NESSUN_CANALE]` nessuno (vedi
 * `backend/app/auth/permissions.py`).
 */
export const NESSUN_CANALE = -1;

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private auth = inject(AuthService);

  has(code: string): boolean {
    const user = this.auth.currentUser();
    if (!user) return false;
    if (user.role === 'super-user') return true;
    return user.permissions.simple[code] === true;
  }

  /**
   * The only role without an admin scope. In the admin area everything that
   * touches the installation — channels, recorders, top-level entities,
   * logs — is theirs; entity admins act within their own entities.
   */
  get superUser(): boolean {
    return this.auth.currentUser()?.role === 'super-user';
  }

  extended<T = unknown>(code: string): T | null {
    return (this.auth.currentUser()?.permissions.extended[code] as T) ?? null;
  }

  get accessibleChannels(): number[] {
    return this.extended<number[]>('accessible_channels') ?? [];
  }

  /** True se il perimetro dell'utente non comprende alcun canale. */
  get senzaCanali(): boolean {
    const canali = this.accessibleChannels;
    return canali.length > 0 && canali.every(c => c === NESSUN_CANALE);
  }

  get maxHistoryDays(): number {
    return this.extended<number>('max_history_days') ?? 90;
  }
}
